import { render, staticRenderFns } from "./CrudExample.vue?vue&type=template&id=3a4539e5"
import script from "./CrudExample.vue?vue&type=script&lang=js"
export * from "./CrudExample.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports